import type { TealiumEventData } from 'src/types/trackingData';

import { EVENT_NAME_HELP_TEXT_EXPAND } from '.';

export const BRANDING_IMPRESSION = 'ecaja-branding-impression';
export const getBrandingImpression = (
  numberOfBrandsDisplayed: number,
  numberOfBrands: number,
): TealiumEventData => ({
  linkName: BRANDING_IMPRESSION,
  eventName: [BRANDING_IMPRESSION],
  numberOfBrands,
  numberOfBrandsDisplayed,
});

const EXISTING_BRANDS_TAB_CLICK = 'ecaja-existing-brand-interacted';
export const existingBrandsTabClick: TealiumEventData = {
  linkName: EXISTING_BRANDS_TAB_CLICK,
  eventName: [EXISTING_BRANDS_TAB_CLICK],
  brandingFlow: 'brand-edit-from-caja',
};

export const EXISTING_BRAND_SELECTED = 'ecaja-existing-brand-selected';

export const getBrandPosition = (position: number): TealiumEventData => ({
  linkName: EXISTING_BRAND_SELECTED,
  eventName: [EXISTING_BRAND_SELECTED],
  position,
});

const CREATE_NEW_BRAND_TAB_CLICK = 'ecaja-create-new-brand-interacted';
export const createNewBrandTabClick: TealiumEventData = {
  linkName: CREATE_NEW_BRAND_TAB_CLICK,
  eventName: [CREATE_NEW_BRAND_TAB_CLICK],
  brandingFlow: 'brand-create-from-caja',
};

const ADD_LOGO_CLICKED = 'ecaja-logo-add-interacted';
export const addLogoClicked: TealiumEventData = {
  linkName: ADD_LOGO_CLICKED,
  eventName: [ADD_LOGO_CLICKED],
};

const REPLACE_LOGO_CLICKED = 'ecaja-logo-replace-interacted';
export const replaceLogoClicked = {
  linkName: REPLACE_LOGO_CLICKED,
  eventName: [REPLACE_LOGO_CLICKED],
};

const NEW_BRAND_UPLOADED = 'ecaja-brand-uploaded';
export const getBrandUploaded = (isCreated: boolean): TealiumEventData => ({
  linkName: NEW_BRAND_UPLOADED,
  eventName: [NEW_BRAND_UPLOADED],
  objectInteraction: isCreated ? 'brand-uploaded' : 'brand-replaced',
});

const CONTEXTUAL_HELP_INTERACTED = 'ecaja-branding-contextual-help-interacted';
const CONTEXTUAL_HELP_OBJECT_INTERACTION = 'branding-contextual-help';
export const contextualHelpInteracted: TealiumEventData = {
  linkName: CONTEXTUAL_HELP_INTERACTED,
  eventName: [EVENT_NAME_HELP_TEXT_EXPAND, CONTEXTUAL_HELP_INTERACTED],
  objectInteraction: CONTEXTUAL_HELP_OBJECT_INTERACTION,
};
